var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("VueGoodTable", {
        attrs: {
          columns: _vm.columnsConfig,
          rows: _vm.groupSurveysWithSurveyName,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions
        },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-danger",
                          on: {
                            click: function($event) {
                              return _vm.onRemoveSurvey(props.row)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-trash" })]
                      )
                    ])
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-success mt-2",
          on: { click: _vm.openSelectModal }
        },
        [_c("i", { staticClass: "fa fa-plus" })]
      ),
      _vm._v(" "),
      _c("SurveySelectModal", {
        ref: "selectModal",
        attrs: { allSurveys: _vm.allSurveysForSelectModal },
        on: { selected: _vm.onSurveysSelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }